import { render } from "./SubscriptionPage.vue?vue&type=template&id=725bb07c"
import script from "./SubscriptionPage.vue?vue&type=script&lang=js"
export * from "./SubscriptionPage.vue?vue&type=script&lang=js"

import "./SubscriptionPage.vue?vue&type=style&index=0&id=725bb07c&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__